<angular-editor [placeholder]="'Enter text here...'" [(ngModel)]="item.FilesNote_Text"></angular-editor>
<div class="p-10" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="12px">
    <button (click)="openFileDialog()" color="primary" mat-raised-button>Upload a file</button>
    <input (change)="fileChange($event, item)" #fileInput type="file" hidden>
    <div class="py-10" *ngFor="let file of item.FilesStatic_Id?.split(';')">
        <mat-card>
            <mat-card-content>
                {{ file }}
            </mat-card-content>
        </mat-card>
    </div>
</div>